import { useLocation, useRouteMatch } from 'react-router-dom';
import { useEffect } from 'react';
import usePrevious from './usePrevious';
import { useSelector } from 'react-redux';

const usePageTracking = () => {
    const location = useLocation();
    const activeMatch = useRouteMatch('/claim/:step');
    const prevActiveMatch = usePrevious(activeMatch);
    const policyType = useSelector(state => state.answer.answer.policyType);
    const claimCategory = useSelector(
        state => state.answer.answer.claimCategory,
    );
    const claimType = useSelector(state => state.answer.answer.claimType);

    const submittedClaimMatch = useRouteMatch('/claim/:id/submitted');
    const prevSubmittedClaimMatch = usePrevious(submittedClaimMatch);

    // general page track
    useEffect(() => {
        if (
            location.pathname.indexOf('/submitted') < 0 &&
            location.pathname.indexOf('claim/') < 0
        ) {
            createNewDataLayer({
                event: 'VirtualPageview',
                language: 'en',
                status: 'signed out',
                virtualPageURL: location.pathname,
            });
        }
    }, [location.pathname]);

    // custom track when creating new claim
    useEffect(() => {
        if (
            location.pathname.indexOf('/submitted') < 0 &&
            location.pathname.indexOf('claim/') >= 0 &&
            ((activeMatch &&
                prevActiveMatch &&
                activeMatch.params.step !== prevActiveMatch.params.step) ||
                (activeMatch && !prevActiveMatch))
        ) {
            const virtualPageUrl = `${getClaimFormBaseVirtualPageUrl(policyType, claimCategory, claimType)}${activeMatch.params.step}/`;

            createNewDataLayer({
                event: 'VirtualPageview',
                language: 'en',
                status: 'signed out',
                virtualPageURL: virtualPageUrl,
            });
        }
    }, [
        activeMatch,
        prevActiveMatch,
        location.pathname,
        policyType,
        claimCategory,
        claimType,
    ]);

    // custom track when user is on submitted page
    useEffect(() => {
        if (
            location.pathname.indexOf('/submitted') >= 0 &&
            location.pathname.indexOf('claim/') >= 0 &&
            ((submittedClaimMatch && !prevSubmittedClaimMatch) ||
                (submittedClaimMatch &&
                    prevSubmittedClaimMatch &&
                    submittedClaimMatch.params.step !==
                        prevSubmittedClaimMatch.params.step))
        ) {
            const virtualPageUrl = `${getClaimFormBaseVirtualPageUrl(policyType, claimCategory, claimType)}abschluss/`;

            createNewDataLayer({
                event: 'VirtualPageview',
                language: 'en',
                status: 'signed out',
                virtualPageURL: virtualPageUrl,
            });
        }
    }, [submittedClaimMatch, location.pathname]);

    const createNewDataLayer = layer => {
        if (window.dataLayer) {
            window.dataLayer.push(layer);
        } else {
            window.dataLayer = [layer];
        }
    };

    const getClaimFormBaseVirtualPageUrl = (
        policyType,
        claimCategory,
        claimType,
    ) => {
        const finalPolicyType = policyType ? `${policyType}/` : '';
        const finalClaimCategory = claimCategory ? `${claimCategory}/` : '';
        const finalClaimType = claimType ? `${claimType}/` : '';
        return (
            '/claims-form/' +
            finalPolicyType +
            finalClaimCategory +
            finalClaimType
        );
    };
};

export default usePageTracking;
